import { __awaiter } from "tslib";
// https://stackoverflow.com/a/34156339
export function download(content, fileName) {
    const a = document.createElement("a");
    const file = new Blob([content], { type: "text/plain" });
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
}
export function upload(accept) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const input = document.createElement("input");
            input.type = "file";
            input.accept = accept;
            input.click();
            input.oninput = () => resolve(input.files);
        });
    });
}
